import React, { useEffect, useState } from "react";
import api from "../utils/api";
import { useNavigate } from "react-router-dom";
import {
    FiBook,
    FiUsers,
    FiCheckCircle,
    FiXCircle,
    FiHelpCircle,
    FiAward,
    FiAlertTriangle,
    FiArrowLeft,
    FiChevronDown,
    FiChevronRight,
    FiBarChart2,
    FiFileText,
    FiUser,
    FiTrendingUp,
    FiClock,
    FiTarget,
    FiPieChart,
    FiAlertCircle
} from 'react-icons/fi';

const AdminDashboard2 = () => {
    const navigate = useNavigate();

    const [subjectWise, setSubjectWise] = useState([]);
    const [paperWise, setPaperWise] = useState([]);
    const [loading, setLoading] = useState(true);
    const [lastPapers, setLastPapers] = useState(5);

    useEffect(() => {
        fetchData();
    }, [lastPapers]);

    async function fetchData() {
        try {
            const fd = new FormData();
            fd.append("loggedInUser", localStorage.getItem("loggedInUser"));
            fd.append("token", localStorage.getItem("authToken"));
            fd.append("programType", "getPaperOverviewSubjectWiseWithLimit3");
            fd.append("lastPapers", lastPapers);

            const res = await api.post("overView/overView2", fd);
            console.log("Admin Dashboard Data:", res);

            setSubjectWise(res.data.subjectWiseCombined || []);
            setPaperWise(res.data.paperWise || []);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    }

    if (loading) {
        return (
            <div className='dashboard-container'
                style={{
                    position: "fixed",
                    inset: 0,

                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    zIndex: 9999,
                }}
            >
                <div
                    style={{
                        background: "#fff",
                        padding: "2.5rem 3rem",
                        borderRadius: "1.25rem",
                        textAlign: "center",
                        boxShadow: "0 20px 40px rgba(0,0,0,0.12)",
                        border: "1px solid #e5e7eb",
                        width: "90%",
                        maxWidth: "360px",
                        marginLeft: "250px"
                    }}
                >
                    {/* Spinner */}
                    <div
                        style={{
                            width: "56px",
                            height: "56px",
                            borderRadius: "50%",
                            border: "4px solid #e5e7eb",
                            borderTop: "4px solid #3b82f6",
                            margin: "0 auto",
                            animation: "spin 1s linear infinite",
                        }}
                    />

                    <h3
                        style={{
                            marginTop: "1rem",
                            marginBottom: "0.25rem",
                            fontSize: "1.25rem",
                            fontWeight: 700,
                            color: "#1f2937",
                        }}
                    >
                        Loading
                    </h3>

                    <p
                        style={{
                            fontSize: "0.875rem",
                            color: "#64748b",
                            marginBottom: "1.5rem",
                        }}
                    >
                        Fetching analytics & insights…
                    </p>

                    {/* Skeleton */}
                    <div style={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
                        {["80%", "60%", "90%"].map((w, i) => (
                            <div
                                key={i}
                                style={{
                                    height: "10px",
                                    width: w,
                                    margin: "0 auto",
                                    borderRadius: "999px",
                                    background:
                                        "linear-gradient(90deg, #e5e7eb 25%, #f3f4f6 37%, #e5e7eb 63%)",
                                    backgroundSize: "400% 100%",
                                    animation: "shimmer 1.4s ease infinite",
                                }}
                            />
                        ))}
                    </div>

                    {/* Inline keyframes */}
                    <style>
                        {`
            @keyframes spin {
              to { transform: rotate(360deg); }
            }
            @keyframes shimmer {
              0% { background-position: 100% 0; }
              100% { background-position: -100% 0; }
            }
          `}
                    </style>
                </div>
            </div>
        );

    }

    console.log("Subject Wise Data:", subjectWise);
    // Calculate totals for summary cards
    const totalQuestions = subjectWise.reduce((sum, sub) => sum + sub.totalQuestions, 0);

    const correctPct =
        totalQuestions > 0
            ? subjectWise.reduce(
                (sum, sub) => sum + (sub.correctPercentage * sub.totalQuestions),
                0
            ) / totalQuestions
            : 0;

    const wrongPct =
        totalQuestions > 0
            ? subjectWise.reduce(
                (sum, sub) => sum + (sub.wrongPercentage * sub.totalQuestions),
                0
            ) / totalQuestions
            : 0;

    const unansweredPct =
        totalQuestions > 0
            ? subjectWise.reduce(
                (sum, sub) => sum + (sub.unansweredPercentage * sub.totalQuestions),
                0
            ) / totalQuestions
            : 0;

    const avgAccuracy =
        subjectWise.length > 0
            ? Math.round(
                subjectWise.reduce(
                    (sum, sub) => sum + sub.averageAccuracy,
                    0
                ) / subjectWise.length
            )
            : 0;


    const correctPctRounded = Math.round(correctPct);
    const wrongPctRounded = Math.round(wrongPct);
    const unansweredPctRounded = Math.round(unansweredPct);



    const handleSubjectClick = (subjectId, subjectName) => {
        navigate(`/chapter-analysis/${subjectId}`, {
            state: {
                subjectName,
                lastPapers
            }
        });
    };

    const handlePaperClick = (paperId, paperName) => {
        navigate(`/dashboard/${paperId}`, {
            state: { paperName }
        });
    };

    const aggregatedPaperWise = paperWise.map(paper => {
        const subjects = paper.subjects || [];

        const totalQuestions = subjects.reduce((s, sub) => s + sub.totalQuestions, 0);
        const totalCorrect = subjects.reduce((s, sub) => s + sub.totalCorrect, 0);
        const totalWrong = subjects.reduce((s, sub) => s + sub.totalWrong, 0);
        const totalUnanswered = subjects.reduce((s, sub) => s + sub.totalUnanswered, 0);

        const correctPct =
            totalQuestions ? Math.round((totalCorrect / totalQuestions) * 100) : 0;

        const wrongPct =
            totalQuestions ? Math.round((totalWrong / totalQuestions) * 100) : 0;

        const unansweredPct =
            totalQuestions ? Math.round((totalUnanswered / totalQuestions) * 100) : 0;

        const averageAccuracy = correctPct;

        return {
            paperId: paper.paperId,
            paperName: paper.paperName,
            totalQuestions,
            correctPct,
            wrongPct,
            unansweredPct,
            averageAccuracy
        };
    });


    const summaryCards = [
        {
            title: "Correct",
            value: `${correctPctRounded}%`,
            icon: <FiCheckCircle size={20} />,
            color: "text-green-600",
            iconBg: "bg-green-100"
        },
        {
            title: "Wrong",
            value: `${wrongPctRounded}%`,
            icon: <FiXCircle size={20} />,
            color: "text-red-600",
            iconBg: "bg-red-100"
        },
        {
            title: "Unanswered",
            value: `${unansweredPctRounded}%`,
            icon: <FiHelpCircle size={20} />,
            color: "text-gray-600",
            iconBg: "bg-gray-100"
        },
        {
            title: "Avg Accuracy",
            value: `${avgAccuracy}%`,
            icon: <FiTrendingUp size={20} />,
            color: "text-blue-600",
            iconBg: "bg-blue-100"
        },
        {
            title: "Total Questions",
            value: totalQuestions,
            icon: <FiFileText size={20} />,
            color: "text-indigo-600",
            iconBg: "bg-indigo-100"
        }
    ];


    return (
        <div className="dashboard-container">


            {/* Header */}
            <div className="dashboard-header">
                <div className="header-content">
                    <h1>Performance Dashboard</h1>
                    <p>Subject-wise analysis & paper performance</p>
                </div>
                <div className="header-controls">
                    <span className="control-label">Show last:</span>
                    <select
                        value={lastPapers}
                        onChange={(e) => setLastPapers(Number(e.target.value))}
                        className="papers-select"
                    >
                        <option value={5}>5 Papers</option>
                        <option value={10}>10 Papers</option>
                        <option value={20}>20 Papers</option>
                    </select>
                </div>
            </div>

            {/* Summary Cards */}
            <div className="summary-grid">
                {summaryCards.map((card, index) => (
                    <div key={index} className="summary-card">
                        <div className={`summary-icon ${card.iconBg}`}>
                            {card.icon}
                        </div>
                        <div className="summary-content">
                            <div className="summary-title">{card.title}</div>
                            <div className={`summary-value ${card.color}`}>{card.value}</div>
                        </div>
                    </div>
                ))}
            </div>

            {/* Charts Grid (Original placement - side by side) */}
            <div className="charts-grid">
                {/* Subject Performance */}
                <div className="chart-card">
                    <div className="card-header">
                        <h2><FiBook size={18} /> Subject Performance</h2>
                    </div>
                    <div className="subject-list">
                        {subjectWise.map((subject) => (
                            <div key={subject.subjectId} className="subject-item">
                                <div className="subject-avatar">
                                    {subject.subjectName.charAt(0)}
                                </div>
                                <div className="subject-content">
                                    <div
                                        className="subject-header"
                                        onClick={() => handleSubjectClick(subject.subjectId, subject.subjectName)}
                                    >
                                        <span className="subject-name">{subject.subjectName}</span>
                                        <span
                                            className="subject-accuracy"
                                            style={{
                                                color:
                                                    subject.averageAccuracy >= 70
                                                        ? "#16a34a"
                                                        : subject.averageAccuracy >= 50
                                                            ? "#eab308"
                                                            : "#dc2626"
                                            }}
                                        >
                                            {subject.averageAccuracy}%
                                        </span>

                                    </div>
                                    <div className="progress-bar">
                                        <div
                                            className="progress-fill"
                                            style={{ width: `${subject.averageAccuracy}%` }}
                                        ></div>
                                    </div>
                                    <div className="subject-stats">
                                        <span>
                                            <FiCheckCircle size={12} /> {subject.correctPercentage}%
                                        </span>

                                        <span>
                                            <FiXCircle size={12} /> {subject.wrongPercentage}%
                                        </span>

                                        <span>
                                            <FiHelpCircle size={12} /> {subject.unansweredPercentage}%
                                        </span>

                                        <span>Q: {subject.totalQuestions}</span>
                                    </div>

                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Performance Distribution */}
                <div className="chart-card">
                    <div className="card-header">
                        <h2><FiPieChart size={18} /> Performance Distribution</h2>
                    </div>
                    <div className="distribution-container">
                        <div className="donut-chart">
                            <div className="donut-ring">
                                <div className="donut-center"></div>
                                <div className="donut-value">
                                    {correctPctRounded}%
                                </div>

                            </div>
                        </div>
                        <div className="distribution-legend">
                            <div className="legend-item">
                                <div className="legend-dot bg-green-500"></div>
                                <span>Correct</span>
                            </div>
                            <div className="legend-item">
                                <div className="legend-dot bg-red-500"></div>
                                <span>Wrong</span>
                            </div>
                            <div className="legend-item">
                                <div className="legend-dot bg-gray-300"></div>
                                <span>Other</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Subject Overview Cards */}
            <div className="section-header">
                <h2>Subject Overview</h2>
                <p>Performance across all subjects</p>
            </div>

            <div className="subject-cards-grid">
                {subjectWise.map((subject) => (
                    <div
                        key={subject.subjectId}
                        className="subject-card"
                        onClick={() => handleSubjectClick(subject.subjectId, subject.subjectName)}
                    >
                        <div className="subject-card-header">
                            <div className="subject-card-avatar">
                                {subject.subjectName.charAt(0)}
                            </div>
                            <div>
                                <h4>{subject.subjectName}</h4>
                                <p>{subject.totalQuestions} questions · {subject.totalPapers} papers</p>
                            </div>
                        </div>

                        <div className="subject-stats-grid">
                            <div className="stat-item">
                                <div className="stat-value text-green-600">
                                    {subject.correctPercentage}%
                                </div>
                                <div className="stat-label">Correct</div>
                            </div>
                            <div className="stat-divider"></div>
                            <div className="stat-item">
                                <div className="stat-value text-red-600">
                                    {subject.wrongPercentage}%
                                </div>
                                <div className="stat-label">Wrong</div>
                            </div>
                            <div className="stat-divider"></div>
                            <div className="stat-item">
                                <div className="stat-value text-orange-600">
                                    {subject.averageAccuracy}%
                                </div>
                                <div className="stat-label">Accuracy</div>
                            </div>

                            <div className="stat-divider"></div>
                            <div className="stat-item">
                                <div className="stat-value text-gray-600">
                                    {subject.unansweredPercentage}%
                                </div>
                                <div className="stat-label">Unanswered</div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            {/* Recent Papers Table (Original placement - full width) */}
            <div className="section-header">
                <h2>Recent Papers</h2>
                <p>Detailed performance per paper</p>
            </div>

            <div className="paper-table-container">
                <table className="paper-table">
                    <thead>
                        <tr>
                            {["Paper", "Questions", "Correct %", "Wrong %", "Unanswered %", "Accuracy", "Status"].map((h) => (
                                <th key={h}>
                                    {h}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {aggregatedPaperWise.map((row, idx) => (
                            <tr
                                key={idx}
                                onClick={() => handlePaperClick(row.paperId, row.paperName)}
                            >
                                <td>
                                    <div className="paper-name">
                                        {row.paperName}
                                    </div>
                                </td>
                                <td>
                                    {row.totalQuestions}
                                </td>
                                <td className="text-green-600 font-bold">
                                    {row.correctPct}%
                                </td>

                                <td className="text-red-600 font-bold">
                                    {row.wrongPct}%
                                </td>

                                <td className="text-gray-500">
                                    {row.unansweredPct}%
                                </td>

                                <td>
                                    <div className="accuracy-cell">
                                        <div
                                            className="accuracy-value"
                                            style={{
                                                color:
                                                    row.averageAccuracy >= 70
                                                        ? "#16a34a"
                                                        : row.averageAccuracy >= 50
                                                            ? "#eab308"
                                                            : "#dc2626"
                                            }}
                                        >
                                            {row.averageAccuracy}%

                                            <div className={`accuracy-dot ${row.averageAccuracy >= 70 ? "bg-green-500" :
                                                row.averageAccuracy >= 50 ? "bg-yellow-500" : "bg-red-500"
                                                }`}></div>
                                        </div>
                                        <div className="accuracy-bar">
                                            <div
                                                className={`accuracy-fill ${row.averageAccuracy >= 70 ? "bg-green-500" :
                                                    row.averageAccuracy >= 50 ? "bg-yellow-500" : "bg-red-500"
                                                    }`}
                                                style={{ width: `${row.averageAccuracy}%` }}
                                            ></div>
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <span className={`status-badge ${row.averageAccuracy >= 70 ? "status-excellent" :
                                        row.averageAccuracy >= 50 ? "status-good" : "status-needs-work"
                                        }`}>
                                        {row.averageAccuracy >= 70 ? "Excellent" :
                                            row.averageAccuracy >= 50 ? "Good" : "Needs Work"}
                                    </span>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>

                <div className="table-footer">
                    <div className="table-info">
                        Showing {paperWise.length} papers
                    </div>
                    <div className="table-pagination">
                        <button className="pagination-btn">
                            ← Previous
                        </button>
                        <button className="pagination-btn pagination-next">
                            Next →
                        </button>
                    </div>
                </div>
            </div>

            <style>
                {`
                    .dashboard-container {
                        min-height: 100vh;
                        background: linear-gradient(135deg, #f5f7fa 0%, #e4edf5 100%);
                        padding: 1.5rem;
                    }

                    /* Loading */
                    .loading-container {
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        min-height: 400px;
                    }
                    
                    .loading-spinner {
                        width: 40px;
                        height: 40px;
                        border: 3px solid #e0f2fe;
                        border-top: 3px solid #0369a1;
                        border-radius: 50%;
                        animation: spin 1s linear infinite;
                    }
                    
                    .loading-text {
                        margin-top: 12px;
                        color: #64748b;
                    }
                    
                    @keyframes spin {
                        to { transform: rotate(360deg); }
                    }

                  
                    /* Header */
                    .dashboard-header {
                        margin: 0 auto 2rem;
                        background: white;
                        border-radius: 1rem;
                        padding: 1.5rem;
                        box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
                        border: 1px solid #e2e8f0;
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                    }

                    .header-content h1 {
                        font-size: 1.75rem;
                        font-weight: 700;
                        color: #1f2937;
                        margin: 0 0 0.5rem;
                        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
                        -webkit-background-clip: text;
                        -webkit-text-fill-color: transparent;
                    }

                    .header-content p {
                        font-size: 0.875rem;
                        color: #6b7280;
                        margin: 0;
                    }

                    .header-controls {
                        display: flex;
                        align-items: center;
                        gap: 0.75rem;
                    }
                    
                    .control-label {
                        font-size: 0.8125rem;
                        font-weight: 500;
                        color: #475569;
                    }
                    
                    .papers-select {
                        padding: 0.5rem 1rem;
                        border-radius: 0.5rem;
                        border: 1px solid #e5e7eb;
                        font-size: 0.875rem;
                        background: white;
                        color: #1f2937;
                        min-width: 120px;
                        font-weight: 500;
                        cursor: pointer;
                        outline: none;
                        transition: border-color 0.2s;
                    }
                    
                    .papers-select:hover {
                        border-color: #cbd5e0;
                    }

                    /* Summary Cards */
                    .summary-grid {
                        margin: 0 auto 1.5rem;
                        display: grid;
                        grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
                        gap: 1rem;
                    }

                    .summary-card {
                        background: white;
                        border-radius: 1rem;
                        padding: 1.25rem;
                        display: flex;
                        align-items: center;
                        gap: 1rem;
                        border: 1px solid #e2e8f0;
                        box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
                        transition: all 0.3s;
                    }

                    .summary-card:hover {
                        transform: translateY(-3px);
                        box-shadow: 0 8px 16px rgba(0, 0, 0, 0.08);
                        border-color: #cbd5e0;
                    }

                    .summary-icon {
                        width: 3rem;
                        height: 3rem;
                        border-radius: 0.75rem;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        flex-shrink: 0;
                    }

                    .summary-content {
                        flex: 1;
                    }

                    .summary-title {
                        font-size: 0.75rem;
                        color: #6b7280;
                        font-weight: 500;
                        margin-bottom: 0.25rem;
                    }

                    .summary-value {
                        font-size: 1.5rem;
                        font-weight: 700;
                    }

                    /* Charts Grid (Original side-by-side layout) */
                    .charts-grid {
                        margin: 0 auto 2rem;
                        display: grid;
                        grid-template-columns: 1fr 1fr;
                        gap: 1.5rem;
                    }
                    
                    .chart-card {
                        background: white;
                        border-radius: 1rem;
                        padding: 1.5rem;
                        box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
                        border: 1px solid #e2e8f0;
                    }
                    
                    .card-header {
                        font-size: 1rem;
                        font-weight: 600;
                        color: #1e293b;
                        margin-bottom: 1.25rem;
                        display: flex;
                        align-items: center;
                        gap: 0.5rem;
                    }
                    
                    .card-header h2 {
                        font-size: 1rem;
                        font-weight: 600;
                        color: #1f2937;
                        margin: 0;
                        display: flex;
                        align-items: center;
                        gap: 0.5rem;
                    }

                    /* Subject List */
                    .subject-list {
                        display: flex;
                        flex-direction: column;
                        gap: 1rem;
                    }
                    
                    .subject-item {
                        display: flex;
                        align-items: center;
                        gap: 0.75rem;
                    }
                    
                    .subject-avatar {
                        width: 2rem;
                        height: 2rem;
                        background: #e0f2fe;
                        color: #0369a1;
                        border-radius: 0.5rem;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        font-weight: 600;
                        font-size: 0.875rem;
                        flex-shrink: 0;
                    }
                    
                    .subject-content {
                        flex: 1;
                    }
                    
                    .subject-header {
                        display: flex;
                        justify-content: space-between;
                        margin-bottom: 0.375rem;
                        cursor: pointer;
                        transition: all 0.2s;
                    }

                    .subject-header:hover {
                        opacity: 0.8;
                    }
                    
                    .subject-name {
                        font-size: 0.875rem;
                        font-weight: 500;
                        color: #1f2937;
                    }
                    
                    .subject-accuracy {
                        font-size: 0.875rem;
                        font-weight: 600;
                        color: #0369a1;
                    }
                    
                    .progress-bar {
                        height: 0.375rem;
                        background: #f1f5f9;
                        border-radius: 0.1875rem;
                        overflow: hidden;
                    }
                    
                    .progress-fill {
                        height: 100%;
                        background: #0369a1;
                        border-radius: 0.1875rem;
                        transition: width 1s ease-in-out;
                    }
                    
                    .subject-stats {
                        display: flex;
                        justify-content: space-between;
                        font-size: 0.6875rem;
                        color: #64748b;
                        margin-top: 0.25rem;
                    }

                    .subject-stats span {
                        display: flex;
                        align-items: center;
                        gap: 0.25rem;
                    }

                    /* Distribution Chart */
                    .distribution-container {
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        gap: 1.25rem;
                        padding: 1rem 0;
                    }
                    
                    .donut-ring {
                        width: 8.75rem;
                        height: 8.75rem;
                        border-radius: 50%;
                      background: conic-gradient(
    #16a34a 0% ${correctPct}%,
    #dc2626 ${correctPct}% ${correctPct + wrongPct}%,
    #e5e7eb ${correctPct + wrongPct}% ${correctPct + wrongPct + unansweredPct}%
);

                        position: relative;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }
                    
                    .donut-center {
                        width: 6.25rem;
                        height: 6.25rem;
                        border-radius: 50%;
                        background: white;
                        position: absolute;
                    }
                    
                    .donut-value {
                        font-size: 1.25rem;
                        font-weight: 600;
                        color: #0369a1;
                        position: relative;
                    }
                    
                    .distribution-legend {
                        display: flex;
                        gap: 1rem;
                    }
                    
                    .legend-item {
                        display: flex;
                        align-items: center;
                        gap: 0.375rem;
                    }
                    
                    .legend-dot {
                        width: 0.75rem;
                        height: 0.75rem;
                        border-radius: 0.125rem;
                    }
                    
                    .legend-item span {
                        font-size: 0.75rem;
                        color: #475569;
                    }

                    /* Section Headers */
                    .section-header {
                        margin: 0 auto 1rem;
                    }
                    
                    .section-header h2 {
                        font-size: 1.125rem;
                        font-weight: 600;
                        color: #1e293b;
                        margin: 0 0 0.25rem 0;
                    }
                    
                    .section-header p {
                        font-size: 0.8125rem;
                        color: #64748b;
                    }

                    /* Subject Cards */
                    .subject-cards-grid {
                        margin: 0 auto 2rem;
                        display: grid;
                        grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
                        gap: 1rem;
                    }
                    
                    .subject-card {
                        background: white;
                        border-radius: 1rem;
                        padding: 1.25rem;
                        box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
                        border: 1px solid #f3f4f6;
                        cursor: pointer;
                        transition: all 0.3s;
                    }
                    
                    .subject-card:hover {
                        transform: translateY(-4px);
                        box-shadow: 0 12px 24px rgba(0, 0, 0, 0.08);
                        border-color: #e5e7eb;
                    }
                    
                    .subject-card-header {
                        display: flex;
                        align-items: center;
                        margin-bottom: 1rem;
                    }
                    
                    .subject-card-avatar {
                        width: 2.5rem;
                        height: 2.5rem;
                        background: #e0f2fe;
                        color: #0369a1;
                        border-radius: 0.625rem;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        font-weight: 600;
                        font-size: 1rem;
                        margin-right: 0.75rem;
                    }
                    
                    .subject-card h4 {
                        font-size: 1rem;
                        font-weight: 600;
                        color: #1f2937;
                        margin: 0 0 0.25rem 0;
                    }
                    
                    .subject-card p {
                        font-size: 0.75rem;
                        color: #6b7280;
                        margin: 0;
                    }
                    
                    .subject-stats-grid {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        padding: 0.75rem;
                        background: #f9fafb;
                        border-radius: 0.5rem;
                    }
                    
                    .stat-item {
                        text-align: center;
                        flex: 1;
                    }
                    
                    .stat-value {
                        font-size: 1.25rem;
                        font-weight: 700;
                        margin-bottom: 0.25rem;
                    }
                    
                    .stat-label {
                        font-size: 0.4875rem;
                        text-transform: uppercase;
                        letter-spacing: 0.5px;
                        color: #6b7280;
                        font-weight: 500;
                    }
                    
                    .stat-divider {
                        width: 1px;
                        height: 2.5rem;
                        background: #e5e7eb;
                    }

                    /* Paper Table */
                    .paper-table-container {
                        margin: 0 auto;
                        background: white;
                        border-radius: 1rem;
                        box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
                        overflow: hidden;
                        border: 1px solid #f3f4f6;
                    }
                    
                    .paper-table {
                        width: 100%;
                        border-collapse: collapse;
                        font-size: 0.875rem;
                    }
                    
                    .paper-table thead {
                        background: #f9fafb;
                        border-bottom: 2px solid #e5e7eb;
                    }
                    
                    .paper-table th {
                        text-align: left;
                        padding: 1rem 1.25rem;
                        font-weight: 600;
                        color: #374151;
                        font-size: 0.75rem;
                        text-transform: uppercase;
                        letter-spacing: 0.5px;
                    }
                    
                    .paper-table tbody tr {
                        border-bottom: 1px solid #f3f4f6;
                        background: white;
                        transition: background-color 0.2s ease;
                        cursor: pointer;
                    }
                    
                    .paper-table tbody tr:nth-child(even) {
                        background: #fafafa;
                    }
                    
                    .paper-table tbody tr:hover {
                        background-color: #f1f5f9;
                    }
                    
                    .paper-table td {
                        padding: 1rem 1.25rem;
                        font-weight: 500;
                        color: #1f2937;
                    }
                    
                    .paper-name {
                        max-width: 200px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }
                    
                    .accuracy-cell {
                        display: flex;
                        flex-direction: column;
                        gap: 0.25rem;
                    }
                    
                    .accuracy-value {
                        display: flex;
                        align-items: center;
                        gap: 0.5rem;
                        color: #0369a1;
                        font-weight: 700;
                    }
                    
                    .accuracy-dot {
                        width: 0.5rem;
                        height: 0.5rem;
                        border-radius: 50%;
                    }
                    
                    .accuracy-bar {
                        height: 0.25rem;
                        background: #f1f5f9;
                        border-radius: 0.125rem;
                        overflow: hidden;
                        width: 5rem;
                    }
                    
                    .accuracy-fill {
                        height: 100%;
                        border-radius: 0.125rem;
                        transition: width 1s ease-in-out;
                    }
                    
                    .status-badge {
                        padding: 0.25rem 0.625rem;
                        border-radius: 0.375rem;
                        font-size: 0.6875rem;
                        font-weight: 600;
                    }
                    
                    .status-excellent {
                        background: #dcfce7;
                        color: #166534;
                    }
                    
                    .status-good {
                        background: #fef3c7;
                        color: #92400e;
                    }
                    
                    .status-needs-work {
                        background: #fee2e2;
                        color: #991b1b;
                    }
                    
                    /* Table Footer */
                    .table-footer {
                        padding: 1rem 1.25rem;
                        background: #f9fafb;
                        border-top: 1px solid #e5e7eb;
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                    }
                    
                    .table-info {
                        font-size: 0.8125rem;
                        color: #6b7280;
                    }
                    
                    .table-pagination {
                        display: flex;
                        gap: 0.5rem;
                    }
                    
                    .pagination-btn {
                        padding: 0.375rem 0.75rem;
                        background: white;
                        border: 1px solid #e5e7eb;
                        border-radius: 0.375rem;
                        font-size: 0.8125rem;
                        color: #374151;
                        cursor: pointer;
                        transition: all 0.2s;
                    }
                    
                    .pagination-btn:hover {
                        border-color: #cbd5e0;
                        background: #f9fafb;
                    }
                    
                    .pagination-next {
                        background: #0369a1;
                        border: none;
                        color: white;
                        font-weight: 500;
                    }
                    
                    .pagination-next:hover {
                        background: #0284c7;
                    }

                    /* Color Utilities */
                    .text-green-600 { color: #16a34a; }
                    .text-red-600 { color: #dc2626; }
                    .text-blue-600 { color: #0369a1; }
                    .text-gray-600 { color: #6b7280; }
                    .text-indigo-600 { color: #4f46e5; }
                    .text-orange-600 { color: #ea580c; }
                    .text-gray-500 { color: #6b7280; }
                    
                    .bg-green-100 { background-color: #dcfce7; color: #16a34a; }
                    .bg-red-100 { background-color: #fee2e2; color: #dc2626; }
                    .bg-gray-100 { background-color: #f3f4f6; color: #4b5563; }
                    .bg-blue-100 { background-color: #dbeafe; color: #1d4ed8; }
                    .bg-indigo-100 { background-color: #e0e7ff; color: #4f46e5; }
                    
                    .bg-green-500 { background-color: #16a34a; }
                    .bg-red-500 { background-color: #dc2626; }
                    .bg-yellow-500 { background-color: #eab308; }
                    .bg-gray-300 { background-color: #d1d5db; }
                    
                    .font-bold { font-weight: 700; }

                    /* Responsive Design */
                    @media (max-width: 768px) {
                        .dashboard-container {
                            padding: 1rem;
                        }
                        
                        .dashboard-header {
                            flex-direction: column;
                            gap: 1rem;
                            align-items: flex-start;
                        }
                        
                        .charts-grid {
                            grid-template-columns: 1fr;
                        }
                        
                        .summary-grid {
                            grid-template-columns: repeat(2, 1fr);
                        }
                        
                        .subject-cards-grid {
                            grid-template-columns: 1fr;
                        }
                        
                        .paper-table {
                            display: block;
                            overflow-x: auto;
                        }
                    }
                    
                    @media (max-width: 480px) {
                        .summary-grid {
                            grid-template-columns: 1fr;
                        }
                        
                        .distribution-legend {
                            flex-direction: column;
                            gap: 0.5rem;
                        }
                        
                        .table-footer {
                            flex-direction: column;
                            gap: 1rem;
                        }

                        .subject-stats-grid {
                            flex-direction: column;
                            gap: 0.5rem;
                        }
                        
                        .stat-divider {
                            display: none;
                        }
                    }
                    
                    @media (min-width: 768px) and (max-width: 1024px) {
                        .subject-cards-grid {
                            grid-template-columns: repeat(2, 1fr);
                        }
                    }
                    
                    @media (min-width: 1024px) {
                        .subject-cards-grid {
                            grid-template-columns: repeat(3, 1fr);
                        }
                    }
                `}
            </style>
        </div>
    );
};

export default AdminDashboard2;